<template>
  <v-layout row wrap>
    <v-flex xs12 md5>
      <v-layout column>
        <v-flex ma-2>
          <FCCRunDetails />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md7>
      <v-layout column>
        <v-flex ma-2>
          <FCCRunPenalities />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import {
    VTextField,
    VDataTable,
    VTooltip,
  } from 'vuetify/lib'
  import FCCRunDetails from '../components/run/FCCRunDetails'
  import FCCRunPenalities from '../components/run/FCCRunPenalities'
  import fccapi from '../fccapi.js'

  export default {
    name: 'Run',
    data: () => ({
      search: "",
      headers: [
        { text: 'competition', value: 'competition' },
        { text: 'title', value: 'title' },
        { text: 'type', value: 'type' },
        { text: 'category', value: 'category' }
      ],
      items: []
    }),
    computed: {
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      }
    },
    props: {
      source: String
    },
    components: {
      VDataTable,
      VTextField,
      VTooltip,
      FCCRunDetails,
      FCCRunPenalities,
    },
    mounted() {
      
    }
  }
</script>